import { useState, useCallback } from 'react';
import { trackWithPlausible } from '../../utils/plausible';

/**
 * Platform-agnostic hook for managing create trip modal state.
 * Handles modal open/close state and tracks trip creation initiation.
 */
export function useCreateTripModal() {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    trackWithPlausible('trip-creation-initiated');
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    open,
    close,
    setIsOpen, // For compatibility with existing modal component
  };
}
